import React from "react";
import { Container } from "reactstrap";

import classes from "@/styles/features/features-main.module.css";
import { featuresPage } from "@/utils/content";
import FeatureSections from "./feature-sections";

const FeaturesMain = () => {
  return (
    <main>
      <section className={classes.hero}>
        <Container>
          <h1>{featuresPage.en.titleText}</h1>
          <p>{featuresPage.en.subTitle}</p>
        </Container>
      </section>
      <FeatureSections />
    </main>
  );
};

export default FeaturesMain;
